import { Report } from "@/types/evaluate";
const extractScoreFromReport = (report: Report): number | null => {
  if (report.score === null) return null;
  if (!report.score) return 0;

  if (typeof report.score === "number") return report.score;

  if (typeof report.score === "object") {
    return (
      (report.score.value as number) ||
      (report.score as any).score ||
      (report.score as any).total ||
      0
    );
  }

  return 0;
};

const generateColor = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const c = (hash & 0x00ffffff).toString(16).toUpperCase();
  const color = `#${"00000".substring(0, 6 - c.length)}${c}`;

  const r = parseInt(color.slice(1, 3), 16);
  const g = parseInt(color.slice(3, 5), 16);
  const b = parseInt(color.slice(5, 7), 16);

  const luminance =
    (0.2126 * r) / 255 + (0.7152 * g) / 255 + (0.0722 * b) / 255;

  // Check contrast ratio with white
  const contrastRatio = (1 + 0.05) / (luminance + 0.05);

  // Darken color if contrast is too low
  if (contrastRatio < 4.5) {
    const darkeningFactor = 0.6;
    const darkerColor = `#${
      Math.max(0, Math.floor(r * darkeningFactor))
        .toString(16)
        .padStart(2, "0") +
      Math.max(0, Math.floor(g * darkeningFactor))
        .toString(16)
        .padStart(2, "0") +
      Math.max(0, Math.floor(b * darkeningFactor))
        .toString(16)
        .padStart(2, "0")
    }`;
    return darkerColor;
  }

  return color;
};

export { extractScoreFromReport, generateColor };
